/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1BindingcodesQueryResponse } from '../../types/GetV1Bindingcodes.ts'

export const getV1BindingcodesQueryKey = () => [{ url: '/v1/BindingCodes' }] as const

export type GetV1BindingcodesQueryKey = ReturnType<typeof getV1BindingcodesQueryKey>

/**
 * {@link /v1/BindingCodes}
 */
export async function getV1Bindingcodes(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1BindingcodesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/BindingCodes`,
        ...requestConfig,
    })
    return res
}

export function getV1BindingcodesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1BindingcodesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1BindingcodesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1BindingcodesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Bindingcodes(config)
        },
    })
}

/**
 * {@link /v1/BindingCodes}
 */
export function useGetV1Bindingcodes<
    TData = ResponseConfig<GetV1BindingcodesQueryResponse>,
    TQueryData = ResponseConfig<GetV1BindingcodesQueryResponse>,
    TQueryKey extends QueryKey = GetV1BindingcodesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1BindingcodesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1BindingcodesQueryKey()

    const query = useQuery(
        {
            ...getV1BindingcodesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
